module.exports = __webpack_public_path__ + "img/sleeve_opening.7aac2a0d.png";